import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayoutRequestKpiCardComponent } from '../payout-request-kpi-card/payout-request-kpi-card.component';

export interface PayoutRequestKpiItem {
  title: string;
  value: number | null;
  subtitle: string;
  valueColor: string;
}

@Component({
  selector: 'bo-payout-request-kpi-list',
  templateUrl: './payout-request-kpi-list.component.html',
  styleUrls: ['./payout-request-kpi-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, PayoutRequestKpiCardComponent],
})
export class PayoutRequestKpiListComponent {
  @Input() kpis: PayoutRequestKpiItem[] = [];
}
